import Box from '@mui/material/Box';
import { PropsWithChildren } from 'react';

export function Body({ children }: PropsWithChildren) {
  return (
    <Box sx={{ display: 'flex', flex: 1, flexDirection: 'column', overflowY: 'auto' }}>
      {children}
    </Box>
  );
}
